import { render, staticRenderFns } from "./PgaOfferEvaluationFixedPriceProjectDetails.vue?vue&type=template&id=5fc2905d&"
import script from "./PgaOfferEvaluationFixedPriceProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationFixedPriceProjectDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc2905d')) {
      api.createRecord('5fc2905d', component.options)
    } else {
      api.reload('5fc2905d', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationFixedPriceProjectDetails.vue?vue&type=template&id=5fc2905d&", function () {
      api.rerender('5fc2905d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/sub-components/PgaOfferEvaluationFixedPriceProjectDetails.vue"
export default component.exports